module.exports = __webpack_public_path__ + "img/BG_orange.4a93b35f.png";